import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a83a1c7a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=a83a1c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83a1c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a83a1c7a')) {
      api.createRecord('a83a1c7a', component.options)
    } else {
      api.reload('a83a1c7a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a83a1c7a&scoped=true&", function () {
      api.rerender('a83a1c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xMo4i2KZhoUf/JS/comp/SearchFilterTokens.vue"
export default component.exports